import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/EndPoint";
import usePatchHook from "../../customHooks/usePatchHook";
const VehicleListComponent = loadable(
  () => import("../../components/Vehicle/VehicleList")
);

const VehicleList = () => {
  const { mutateAsync, isLoading } = usePatchHook({
    queryKey: ["vehicle"],
  });
  const handleIsActive = async (value, id) => {
    const url = `${APIS.VEHILCE}${id}/`;
    const formData = {
      is_active: value,
    };
    try {
      await mutateAsync({ url, formData, setError: () => {} });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <StatusIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Vehicle</span>
      </div>
      <VehicleListComponent handleIsActive={handleIsActive} />
    </>
  );
};

export default VehicleList;
